import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar-view',
  templateUrl: './avatar-view.component.html',
  styleUrls: ['./avatar-view.component.scss'],
})
export class AvatarViewComponent  {
  @Input() avatarUrl: string;
  @Input() size = '75px';
}
